export enum SigningProcessStep {
	SigningProcessRedirect,
	FLDRedirect,       
	NeutralSelfie,
	PepForm,
	SignaturePad,
	ProductRecived,
}
